// src/redux/slices/authSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ApiBaseUrl, updateSubscriptionDataProfessional } from "../../Utils/Constants";
import { showToast } from "../../Helper/Toast";

export const hitUpdateSubscriptionProfessionalApi = createAsyncThunk("hitUpdateSubscriptionProfessionalApi", async (payload) => {
  try {
    const config = {
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Authorization: payload.token,
      },
    };
    const url = ApiBaseUrl + updateSubscriptionDataProfessional;
    const response = await axios.put(url, payload, config);
    return response.data;
  } catch (error) {
    showToast(error.response.data.message, "error");
    throw error.response.data;
  }
});

const updateSubscriptionProfessionalSlice = createSlice({
  name: "updateSubscriptionProfessionalReducer",
  initialState: {
    isLoading: false,
    data: null,
  },
  reducers: {
    clearhitUpdateSubscriptionProfessionalData: (state) => {
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(hitUpdateSubscriptionProfessionalApi.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(hitUpdateSubscriptionProfessionalApi.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(hitUpdateSubscriptionProfessionalApi.rejected, (state) => {
        state.isError = false;
      });
  },
});

export const { clearhitUpdateSubscriptionProfessionalData } = updateSubscriptionProfessionalSlice.actions;
export default updateSubscriptionProfessionalSlice.reducer;
